import { useNavigate } from 'react-router-dom';
import { useLang } from '../context/LangContext';

function catName(c, lang) {
  if (!c) return '';
  if (lang === 'ar') return c.name_ar || '';
  if (c.translations && c.translations[lang] && c.translations[lang].name) {
    return c.translations[lang].name;
  }
  if (lang === 'en') return c.name_en || c.name_ar || '';
  return c.name_ar || '';
}

export default function SiteFooter({ categories }) {
  const { t, lang } = useLang();
  const navigate = useNavigate();
  const go = (path) => (e) => { e.preventDefault(); navigate(path); };

  return (
    <footer className="site-footer">
      <div className="footer-main">
        <div className="footer-brand">
          <div style={{display:'flex',alignItems:'center',gap:'.9rem',marginBottom:'.7rem'}}>
            <img src="/images/iiis-logo.webp" className="logo-seal-img" style={{width:48,height:48}} width="48" height="48" alt="IIIS" />
            <div style={{fontFamily:'var(--fam-display)',fontSize:'var(--t-lg)',color:'rgba(255,255,255,.7)'}}>{t('footer.name')}</div>
          </div>
          <p>{t('footer.about')}</p>
        </div>
        <div className="footer-col">
          <h4>{t('footer.fatwa.head2')}</h4>
          <ul>
            <li><a href="/fatwas" onClick={go('/fatwas')}>{t('footer.fatwa.all2')}</a></li>
            {categories.slice(0,5).map(c=>(
              <li key={c.id}><a href={`/fatwas?cat=${c.id}`} onClick={e=>{e.preventDefault();navigate(`/fatwas?cat=${c.id}`);}}>{catName(c, lang)}</a></li>
            ))}
          </ul>
        </div>
        <div className="footer-col">
          <h4>{t('footer.content.head2')}</h4>
          <ul>
            <li><a href="/articles"  onClick={go('/articles')}>{t('footer.articles2')}</a></li>
            <li><a href="/lectures"  onClick={go('/lectures')}>{t('footer.lectures2')}</a></li>
            <li><a href="/scholars"  onClick={go('/scholars')}>{t('footer.scholars2')}</a></li>
            <li><a href="/causes"    onClick={go('/causes')}>{t('footer.causes2')}</a></li>
          </ul>
        </div>
        <div className="footer-col">
          <h4>{t('footer.inst.head2')}</h4>
          <ul>
            <li><a href="/about"   onClick={go('/about')}>{t('footer.about.link2')}</a></li>
            <li><a href="/contact" onClick={go('/contact')}>{t('footer.contact2')}</a></li>
            <li><a href="/donate"  onClick={go('/donate')}>{t('footer.donate2')}</a></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <span>{t('footer.copyright')}</span>
        <span className="footer-credit">
          <bdi>{t('footer.credit')} <strong>Mind Track</strong></bdi>
          <span className="footer-credit-sep"> · </span>
          <a href="mailto:info@mohamednour.eu">info@mohamednour.eu</a>
        </span>
        <div style={{display:'flex',gap:'1rem'}}>
          <a href="/about"   onClick={go('/about')}>{t('footer.privacy2')}</a>
          <a href="/contact" onClick={go('/contact')}>{t('footer.contact2')}</a>
        </div>
      </div>
    </footer>
  );
}